export default "__VITE_ASSET__CydFy03l__"